import { render, staticRenderFns } from "./ListCliente.vue?vue&type=template&id=21d0de35&"
import script from "./ListCliente.vue?vue&type=script&lang=js&"
export * from "./ListCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports